module.exports = __webpack_public_path__ + "img/community.2609c168.svg";